// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"4e602207","236":"109b924a","322":"24bf7a2f","625":"5b03f1e4","670":"72e19bed","673":"3fc0379f","834":"47431acd","887":"d6b7e329","903":"04739e74"}[chunkId] + ".chunk.js";
};